import { OAuthTokenRequest, OAuthTokenResponse } from '../models/auth';
import { Observable, of as observableOf } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { User } from '../models/customer';

import { tokenStorage, memberStorage, accountService, httpClient } from '../shop/shop-context';

export class AuthService {
	token(request: OAuthTokenRequest): Observable<OAuthTokenResponse> {
		const url = `/oauth/token`;
		return httpClient.post<OAuthTokenResponse>(url, request).pipe(
			map(token => {
				if (token && token.access_token) {
					tokenStorage.set(token);
				}
				return token;
			})
		);
	}

	authenticate(request: OAuthTokenRequest): Observable<User> {
		return this.token(request).pipe(
			mergeMap(token => {
				// Get and store member and user
				return accountService.get().pipe(
					mergeMap(user => {
						// TODO: is this save?
						//this._store.dispatch(new contextActions.UserLoggedIn(user.id));
						//this._store.dispatch(new userActions.SetUser(user));
						memberStorage.set(user);
						return observableOf(user);
					})
				);
			})
		);
	}

	logout(): Observable<void> {
		const url = `/connect/account/logout`;
		return httpClient.post(url, {}, true);
	}
}
